import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';


export class Filter {

  key : string;
  value : any;

}

@Injectable({
  providedIn: 'root'
})
export class PortfolioFilterService {
  //private currentFilterSubject: BehaviorSubject<Filter[]>;
  //public currentFilters: Observable<Filter[]>;
  private dataSource  = new BehaviorSubject<Filter[]>([]);
  public data = this.dataSource.asObservable();

  private filters : Array<Filter>;

  constructor() { 
  	this.clearFilters();
  }

  clearFilters() {
    
    let period = this.DataParaString(new Date())
    this.filters = [
          
    ];

    this.dataSource.next(this.filters);
  }


  addFilter(obj : Filter) {
    
    let index = this.filters.findIndex(x => x.key == obj.key);
    if (index === -1) {
       this.filters.push(obj); 
    } else {
       this.filters[index].value = obj.value;
    }        

    this.dataSource.next(this.filters);
    //console.log("filter service, this filters");
    //console.log(this.filters)
  }

  addFilters(obj : Array<Filter>) {

    for (var i = 0; i < obj.length; ++i) {
      let index = this.filters.findIndex(x => x.key == obj[i].key);
      if (index === -1) {
         this.filters.push(obj[i]); 
      } else {
         this.filters[index].value = obj[i].value;
      } 
    }
    this.dataSource.next(this.filters);
  }

  getValueOf(key) {
    let index = this.filters.findIndex(x => x.key == key);
    if (index >= 0) {
       return this.filters[index].value;   
    } else {
       return null;
    }
  }

  DataParaString(o) {
    let year = o.getFullYear();
    let month = Number(o.getMonth())+1;
    let newMonth = String(month)

    if (month < 10) {
         newMonth = "0" + String(month)
    }  

    let valor = year + newMonth;
    return valor
  }
}
    